import genApi, { get } from "@/quick/gen-api";
import _ from "lodash";
export default {
  // functional: true,
  // Props 是可选的
  props: ["config", "context"],
  data() {
    return {
      valueKey: config.valueKey || "value",
      labelKey: config.labelKey || "label",
      argString: "{}"
    };
  },
  watch: {
    config: {
      immediate: true,
      handler(newValue, oldValue) {
        this.handleMapValue();
      },
      deep: true
    },
    "context.ruleForm": {
      handler(nv) {
        if (this.config.mulitType == "url") this.handleArgs();
      },
      deep: true
    },
    argString() {
      this.handleMapValue(true);
    }
  },
  computed: {
    listName() {
      return this.getUniqueName();
    },
    list() {
      return this.context.autoConfig.allList[this.listName] || [];
    }
  },
  methods: {
    getLabelFormList(value) {
      let { valueKey, labelKey } = this;
      let temp = this.list.find(item => item[valueKey] == value);
      if (temp) {
        return temp[labelKey];
      }
      return "无对应值";
    },
    getUniqueName() {
      let base = `map_${this.config.prop}_list`;
      if (this.config.unique) {
        base += `_${this.config.uniqueID}`;
      }
      return base;
    },
    looseJsonParse(obj) {
      return Function('"use strict";return (' + obj + ")")();
    },
    handleArgs: _.debounce(function handleArgs() {
      let v = {};
      try {
        v = Function(
          "context",
          `with(context.ruleForm){
            return   (${this.config.args} )
          }`
        )(this.context);
      } catch (e) {
        console.log("conditon -> e", e);
      }
      this.argString = JSON.stringify(v);
    }, 500),
    handleMapValue(newArgs = false) {
      let src = this.config.map.trim();
      if (src == "") {
        return;
      }
      let newLabel = this.getUniqueName();
      let allList = this.context.autoConfig.allList;

      if (!allList[newLabel] || newArgs==true) {
        this.$set(allList, newLabel, []);
        if (src[0] == "[" && src[src.length - 1] == "]") {
          allList[newLabel] = this.looseJsonParse(src);
        } else {
          get(src)().then(resp => {
            allList[newLabel] = resp.data;
          });
        }
      }
    }
  }
};
